import type { OtaManifest } from './ota'

export type OtaManifestRejectReason = 'not_object' | 'url'

export class OtaManifestRejectedError extends Error {
  readonly reason: OtaManifestRejectReason
  constructor(reason: OtaManifestRejectReason) {
    // No URL in the message, so GlitchTip groups every rejection together.
    super(`OTA manifest rejected: ${reason}`)
    this.name = 'OtaManifestRejectedError'
    this.reason = reason
  }
}

// A rewritten bundle URL is one device's traffic being tampered with; the pin
// already refused it and drift is caught by scripts/ota-bundle-url.test.ts (#673).
export function isForgedManifestUrl(err: unknown): err is OtaManifestRejectedError {
  return err instanceof OtaManifestRejectedError && err.reason === 'url'
}

// Must stay identical to the URL release-ota.ts writes (scripts/ota-bundle-url.ts;
// its test fails on drift) — any drift makes every device ignore every release. Equality rather than a prefix
// match: the sha256 comes from the same manifest, so only the exact URL for its
// own version stops a rewritten manifest forcing a downgrade to an older
// genuine bundle (#621).
export function expectedBundleUrl(bucket: string, channel: string | null, version: string): string {
  const dir = channel ? `ota/preview/${channel}` : 'ota'
  return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(`${dir}/bundle-${version}.zip`)}?alt=media`
}

export function parseOtaManifest(raw: unknown, ctx: { bucket: string; channel: string | null }): OtaManifest {
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) throw new OtaManifestRejectedError('not_object')
  const m = raw as { version?: unknown; url?: unknown }
  if (typeof m.version !== 'string' || m.url !== expectedBundleUrl(ctx.bucket, ctx.channel, m.version)) {
    throw new OtaManifestRejectedError('url')
  }
  return raw as OtaManifest
}
